import React from 'react'
import PropTypes from 'prop-types'

import * as S from './direction-list-styled'

const DirectionList = ({ directions }) => (
  <S.List>
    {directions.map((text, i) => (
      <S.ListItem key={i}>
        <S.Step>{`Step ${i+1}`}</S.Step>
        <S.Direction>{text}</S.Direction>
      </S.ListItem>
    ))}
  </S.List>
)

DirectionList.propTypes = {
  directions: PropTypes.array.isRequired,
}

export { DirectionList }